import classNames from 'clsx';
import { useEffect, useState, type PropsWithChildren } from 'react';

import styles from './FeedbackBar.module.css';

import { Icon } from 'components/Icon';
import { Repeater } from 'components/Repeater';

/** Represents a component to show feedback within a Page. */
export const FeedbackBar = ({ children }: PropsWithChildren) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const close = () => {
    setIsVisible(false);
  };

  return (
    <div className={classNames(styles['feedback-bar'], { [styles['feedback-bar--visible']]: isVisible })} role="alert">
      <Repeater flexDirection="row">
        <Icon className={classNames(styles['feedback-bar__icon'])} name="CheckCircle" />
        {children}
      </Repeater>
      <button className={classNames(styles['feedback-bar__close-button'])} type="button" onClick={close}>
        <Icon name="Cross" size={24} />
      </button>
    </div>
  );
};
